import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { Link, withRouter } from 'react-router-dom';
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class CreatorReferrals extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            referrals: [],
            referralsLoading: false,
            ReferralsTable: {
                title: "Creator Referrals",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'createdDate',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getCreatorReferrals();
    };

    getCreatorReferrals = async () => {
        let url = `/api/Account/GetUsersByReferralUserId?referralUserId=` + this.props.loggedInUser.id;

        this.setState({ referralsLoading: true });

        try {
            const referrals = await getRequest(url);

            this.setState({
                referrals,
                referralsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching referrals:", error);
            this.setState({ referrals: [], referralsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "userName",
                label: "Username",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <Link to={`/prf/${value}`} className="brandOrange">
                                <span>{value}</span>
                            </Link>
                        );
                    }
                }
            },
            {
                name: "instagramUsername",
                label: "Instagram Username",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        if (value) {
                            return (
                                <a href={`https://instagram.com/${value}/`} target="_blank" rel="noreferrer">{value}</a>
                            );
                        }
                        return "-";
                    }
                }
            },
            {
                name: "totalNumberOfLinks",
                label: "# of Links",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    }
                }
            },
            {
                name: "lockerCount",
                label: "# of Lockers",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return value ?? "-";
                    }
                }
            },
            {
                name: "commissionCount",
                label: "Has Sales",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        if (value && typeof value === "number") {
                            if (value > 0) {
                                return "✅ Yes"
                            } 
                        }
                        return "❌ No"
                    }
                }
            },
            {
                name: "createdDate",
                label: "Date Referred",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value) => {
                        return value
                            ? new Date(value).toLocaleDateString()
                            : "-";
                    }
                }
            },            
        ];

        const noMatchMessage = this.state.referralsLoading
            ? "LOADING..."
            : (
                <div>
                    <p
                        style={{
                            marginBottom: "20px",
                            marginLeft: this.props.screenWidth < 960 ? "-100%" : "",
                            fontSize: "20px"
                        }}
                    >
                        You have no referred Creators <span style={{ fontStyle: "italic", textDecoration: "", fontWeight: "bold" }}>yet</span>...
                    </p>
                    <p
                        style={{
                            marginBottom: 0,
                            marginLeft: this.props.screenWidth < 960 ? "-100%" : ""
                        }}
                    >
                        Click <span className="brandOrange" style={{ fontWeight: "bold", cursor: 'pointer' }} onClick={this.props.showReferralModal}>Refer A Creator</span> and share the link to sign up Creators and <span style={{ fontWeight: "bold" }}>earn extra $$$</span>!!! <img src="/images/flame.png" alt="" style={{ verticalAlign: "top" }} /><img src="/images/flame.png" alt="" style={{ verticalAlign: "top" }} /><img src="/images/flame.png" alt="" style={{ verticalAlign: "top" }} />
                    </p>
                </div>
            );


        return (
            <div>
                <ThemeProvider theme={this.state.ReferralsTable.getTheme()}>
                    <MUIDataTable
                        key={this.props.screenWidth} // <-- Add this line
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px", fontWeight: "bold" }}>Creator Referrals</p>
                                <p style={{ fontSize: '16px', marginTop: "10px" }}><span className="brandOrange" style={{ fontWeight: "bold", cursor: 'pointer' }} onClick={this.props.showReferralModal}>Refer a fellow Creator to RockPorch</span> and earn 2.5% of their sales for 12 months—on top of what they make <span style={{ fontStyle: "italic" }}>(it doesn’t affect their commissions!)</span></p>
                                <p style={{ fontSize: '16px', marginTop: "5px" }}>It’s an easy way to build passive income!</p>
                            </div>
                        }
                        data={this.state.referrals ?? []}
                        columns={columns}
                        options={{
                            ...this.state.ReferralsTable.options,
                            textLabels: {
                                body: { noMatch: noMatchMessage }
                            },
                            selectableRows: "none",
                            search: false,
                            filter: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default withRouter(CreatorReferrals);